import { useFetchFromHarvestApp as fetch } from './useApi'

export default function () {
  const { result, error, loading } = fetch('/company')

  let company = null

  if (result) {
    const {
      clock,
      time_format: timeFormat,
      date_format: dateFormat,
      decimal_symbol: decimalSymbol,
      wants_timestamp_timers: wantsTimestampTimers,
      base_uri: baseUri,
      thousands_separator: thousandsSeparator,
    } = result

    company = {
      clock,
      decimalSymbol,
      timeFormat,
      dateFormat,
      wantsTimestampTimers,
      baseUri,
      thousandsSeparator,
    }
  }

  return { company, error, loading }
}

export const DecimalSymbol = {
  Comma: ',',
  Period: '.',
}

export const ThousandsSeparator = {
  Apostrophe: "'",
  Comma: ',',
  Period: '.',
  Space: ' ',
}

export const Clock = {
  _12H: '12h',
  _24H: '24h',
}

export const TimeFormat = {
  Decimal: 'decimal',
  HoursMinutes: 'hours_minutes',
}
